import { CloseButton } from '@orn/shared-web/components/Button';
import { BellIcon } from '@orn/shared-web/icons';
import { cx } from '@orn/shared-web/utils/cx';

/** Figma's "Notification Center", in the app's sentence case. */
export const ALERTS_CENTER_TITLE = 'Notification center';

interface IAlertsCenterHeaderProps {
  /**
   * At `xl+` this collapses the column back to the assistant thread; below it,
   * where the center is the `/alerts` route, it leaves for `/assistant`.
   */
  onClose: () => void;
  className?: string;
}

/**
 * The Alerts Center's 72px header: bell, title, and the X that gives the column
 * back. Pinned — it sits outside the list's scroll container, so the close
 * affordance stays reachable however far the user has scrolled, and it renders
 * in every state including the error one.
 */
const AlertsCenterHeader = ({ onClose, className }: IAlertsCenterHeaderProps) => (
  <div className={cx('h-18 flex shrink-0 items-center gap-2 px-4', className)}>
    <BellIcon aria-hidden="true" className="text-fg-quaternary size-5 shrink-0" />
    <div className="text-primary min-w-0 flex-1 truncate text-xl font-semibold">{ALERTS_CENTER_TITLE}</div>
    <CloseButton size="sm" label="Close notification center" onPress={onClose} />
  </div>
);

export default AlertsCenterHeader;
